import { DashboardComponentPair } from "../../../../models/dashboard";
import { WorkerDashboardComponent } from "./worker-dashboard.component";
import { WorkerDashboardFormComponent } from "./worker-dashboard-form.component";

export const ComponentPair: DashboardComponentPair = {
    view: WorkerDashboardComponent,
    form: WorkerDashboardFormComponent,
}
